// extracted by css-extract-rspack-plugin
export default {"hidden":"hidden-EOUMrc"};